"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1859,4376],{

/***/ 68470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ab_cards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84691);




var Disfrute = function(param) {
    var classname = param.classname, category = param.category, moduloCross = param.moduloCross, i18n = param.i18n;
    var ref, ref1;
    var rowArray = [];
    var i, j, temporary, chunk = 3;
    for(i = 0, j = category === null || category === void 0 ? void 0 : (ref = category.products) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.length; i < j; i += chunk){
        var ref2;
        temporary = category === null || category === void 0 ? void 0 : (ref2 = category.products) === null || ref2 === void 0 ? void 0 : ref2.nodes.slice(i, i + chunk);
        rowArray.push(temporary);
    }
    var disfrute = moduloCross === null || moduloCross === void 0 ? void 0 : moduloCross.modCrossDisfrute;
    // console.log("Disfrute", disfrute);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_cards__WEBPACK_IMPORTED_MODULE_1__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: classname ? classname : rowArray.length % 2 == 1 ? "beige" : "white",
        textStyle: {
            maxWidth: 455
        }
    }, disfrute), {
        title: i18n.language == "en" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleEn) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.title) : i18n.language == "de" ? (disfrute === null || disfrute === void 0 ? void 0 : disfrute.titleDe) || (disfrute === null || disfrute === void 0 ? void 0 : disfrute.title) : disfrute === null || disfrute === void 0 ? void 0 : disfrute.title,
        i18n: i18n
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Disfrute);


/***/ })

}]);